import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import AtosService from '../../../../services/ato-auth';
import { Link } from 'react-router-dom';
import Moment from 'moment';





const Ato = () => {
    const [numAto, setNumAto] = useState("");
    const [dataAto, setDataAto] = useState("");
    const [categoria, setCategoria] = useState("");
    const [descricao, setDescricao] = useState("");
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const ato = new FormData();
        ato.append("numAto", numAto)
        ato.append("dataAto", dataAto)
        ato.append("descricao", descricao)
        ato.append("categoria", categoria)
        ato.append("arquivo", arquivo);
        return ato
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const ato = await AtosService.cadastro(dados)
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNumAto("")
        setDataAto("")
        setDescricao("")
        setCategoria("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="numAto">
                                <FloatingLabel
                                    label="Número do Ato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="numAto"
                                        value={numAto}
                                        onChange={e => setNumAto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataAto">
                                <FloatingLabel
                                    label="Data do Ato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataAto"
                                        value={dataAto}
                                        onChange={e => setDataAto(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Despacho">Despacho</option>
                                        <option value="Ofício">Ofício</option>
                                        <option value="Memorando">Memorando</option>
                                        <option value="Processo Administrativo">Processo Administrativo</option>
                                        <option value="Ofício Circular">Ofício Circular</option>
                                        <option value="Despacho de Encaminhamento">Despacho de Encaminhamento</option>
                                        <option value="Decisão">Decisão</option>
                                        <option value="Decreto">Decreto</option>
                                        <option value="Instrução Normativa">Instrução Normativa</option>
                                        <option value="Ato Administrativo Não Especificado">Ato Administrativo Não Especificado</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Laudo">Laudo</option>
                                        <option value="Laudo Pericial">Laudo Pericial</option>
                                        <option value="Íntegra de Processo Administrativo">Íntegra de Processo Administrativo</option>
                                        <option value="Ações de Governo">Ações de Governo</option>
                                        <option value="Decisão Judicial">Decisão Judicial</option>
                                        <option value="Processo Judicial">Processo Judicial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="Descrição">
                                <FloatingLabel
                                    label="Descrição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row xs={12}>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="arquivo">
                                <Form.Label>Arquivo do Ato</Form.Label>
                                <Form.Control
                                    required
                                    type="file"
                                    name="arquivo"
                                    onChange={handleUpload}
                                    accept="application/pdf"

                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/atos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Ato Cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/atos/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Atos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/atos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Ato;